import { css } from 'linaria';

const enter = css`
  opacity: 0;
`;
const enterActive = css`
  opacity: 1;
  transition: opacity 300ms;
`;
const exit = css`
  opacity: 1;
`;
const exitActive = css`
  opacity: 0;
  transition: opacity 300ms;
`;

export const classNames = {
  enter,
  enterActive,
  exit,
  exitActive,
};
